import { Controller, useForm } from "react-hook-form";

import { Button, IconButton, InputAdornment, styled } from "@mui/material";
import CustomTextField from "../../../../ui/components/Form/TextField";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useCompleteAdressInfo } from "../../../misc/api/getCompleteAdressInfo";
import { Search, Visibility, VisibilityOff } from "@mui/icons-material";
import MaskedInput from "react-text-mask";
import { useSignUpUser } from "../../api/signUpUser";
import { createNotification } from "../../../../shared/store/notifications";
import { useState } from "react";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useSignUpParams } from "../../api/getSignUpParams";

const MaskedCPFInput = (props) => {
  const { ref, ...other } = props;
  let mask = null;
  mask = [
    /\d/,
    /\d/,
    /\d/,
    ".",
    /\d/,
    /\d/,
    /\d/,
    ".",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
  ];
  return (
    <MaskedInput
      {...other}
      ref={ref}
      mask={mask}
      placeholderChar={"\u2000"}
      guide
    />
  );
};
const MaskedCEPInput = (props) => {
  const { ref, ...other } = props;
  let mask = null;
  mask = [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];
  return (
    <MaskedInput
      {...other}
      ref={ref}
      mask={mask}
      placeholderChar={"\u2000"}
      guide
    />
  );
};

const MaskedPhoneNumberInput = (props) => {
  const { ref, ...other } = props;
  let mask = null;
  mask = [
    "(",

    /\d/,
    /\d/,

    ")",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,

    /\d/,
  ];
  return (
    <MaskedInput
      {...other}
      ref={ref}
      mask={mask}
      placeholderChar={"\u2000"}
      guide
    />
  );
};

const defaultValues = {
  name: "",
  email: "",
  password: "",
  confirmPassword: "",
  documentNumber: "",
  postalCode: "",
  addressDescription: "",
  addressComplement: "",
  neighborhood: "",
  city: "",
  state: "",
  number: "",
};

const StyledForm = styled("form")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
  padding: theme.spacing(2),
}));

const getFieldLabel = (fieldName) => {
  switch (fieldName) {
    case "name":
      return "Nome";
    case "phoneNumber":
      return "Número de telefone";
    case "email":
      return "Email";
    case "password":
      return "Senha";
    case "documentNumber":
      return "CPF";
    case "postalCode":
      return "CEP";
    case "addressDescription":
      return "Rua";
    case "addressComplement":
      return "Complemento";
    case "neighborhood":
      return "Bairro";
    case "city":
      return "Cidade";
    case "state":
      return "Estado";
    case "number":
      return "Número da casa";
    case "birthDayDate":
      return "Data de nascimento";
    case "country":
      return "País";
    case "companyName":
      return "Empresa";
    case "jobPosition":
      return "Cargo";
    default:
      return "";
  }
};

function PhoneNumberField({ formMethods }) {
  return (
    <CustomTextField
      formMethods={formMethods}
      fieldName={"phoneNumber"}
      labelText={"Número de Telefone"}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        inputComponent: MaskedPhoneNumberInput,
      }}
    />
  );
}

function PostalCodeField({ formMethods }) {
  const verifyZip = useCompleteAdressInfo({});

  const handleVerifyZip = () => {
    verifyZip.mutate(formMethods.getValues("postalCode"), {
      onSuccess: (data) => {
        formMethods.setValue("state", data.estado);
        formMethods.setValue("neighborhood", data.bairro);
        formMethods.setValue("city", data.localidade);
        formMethods.setValue("addressDescription", data.logradouro);

        return;
      },
    });
  };
  return (
    <span className="flex align-center justify-between">
      <CustomTextField
        formMethods={formMethods}
        fieldName={"postalCode"}
        labelText={"CEP"}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          inputComponent: MaskedCEPInput,
        }}
      />
      <Button
        variant="contained"
        endIcon={<Search />}
        onClick={handleVerifyZip}
      >
        Buscar CEP
      </Button>
    </span>
  );
}

function PasswordField({ formMethods }) {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <>
      <CustomTextField
        formMethods={formMethods}
        fieldName={"password"}
        labelText={"Senha"}
        InputLabelProps={{ shrink: true }}
        type="password"
      />
      <CustomTextField
        formMethods={formMethods}
        fieldName={"passwordConfirmation"}
        labelText={"Confirmar senha"}
        InputLabelProps={{ shrink: true }}
        type={showPassword ? "text" : "password"}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleClickShowPassword}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </>
  );
}

function BirthDayDateField({ formMethods }) {
  return (
    <Controller
      control={formMethods.control}
      name="birthDayDate"
      render={({ field, ...rest }) => {
        return (
          <DateTimePicker
            views={["year", "month", "day"]}
            slotProps={{
              textField: {
                error: !!formMethods.formState.errors["birthDayDate"],
                helperText:
                  formMethods.formState.errors["birthDayDate"]?.message,
              },
            }}
            label="Data de nascimento"
            value={field.value}
            onChange={field.onChange}
            placeHolderText="DD/MM/AAAA"
          />
        );
      }}
    />
  );
}

function Field({ fieldName, formMethods }) {
  switch (fieldName) {
    case "documentNumber":
      return (
        <CustomTextField
          formMethods={formMethods}
          fieldName={"documentNumber"}
          labelText={"CPF"}
          InputProps={{
            inputComponent: MaskedCPFInput,
          }}
          InputLabelProps={{ shrink: true }}
        />
      );
    case "phoneNumber":
      return <PhoneNumberField formMethods={formMethods} />;
    case "postalCode":
      return <PostalCodeField formMethods={formMethods} />;
    case "password":
      return <PasswordField formMethods={formMethods} />;
    case "birthDayDate":
      return <BirthDayDateField formMethods={formMethods} />;
    default:
      return (
        <CustomTextField
          formMethods={formMethods}
          fieldName={fieldName}
          labelText={getFieldLabel(fieldName)}
          InputLabelProps={{ shrink: true }}
        />
      );
  }
}

export default function SecondStep({
  onSuccess = () => {},
  initialValues = defaultValues,
  submitButtonRef,
}) {
  const signUpParamsQuery = useSignUpParams();

  const mandatoryFieldNames = [
    "name",
    "email",
    "phoneNumber",
    ...signUpParamsQuery.data?.signUpRegistrationFields,
  ];

  const getFieldSchema = (fieldName) => {
    switch (fieldName) {
      case "postalCode":
        return yup.string();
      case "addressComplement":
        return yup.string();
      case "email":
        return yup
          .string()
          .required("Campo obrigatório")
          .email("Email inválido");
      case "passwordConfirmation":
        return yup.string().when([], {
          is: () => mandatoryFieldNames.includes("password"),
          then: () =>
            yup
              .string()
              .oneOf([yup.ref("password")], "As senhas devem ser iguais"),
          otherwise: () => yup.string(),
        });

      default:
        return yup.string().when([], {
          is: () => mandatoryFieldNames.includes(fieldName),
          then: () => yup.string().required("Campo obrigatório!"),
          otherwise: () => yup.string().notRequired(),
        });
    }
  };

  const SignUpSchema = yup.object().shape({
    name: getFieldSchema("name"),
    phoneNumber: getFieldSchema("phoneNumber"),
    email: getFieldSchema("email"),
    password: getFieldSchema("password"),
    passwordConfirmation: getFieldSchema("passwordConfirmation"),
    documentNumber: getFieldSchema("documentNumber"),
    postalCode: getFieldSchema("postalCode"),
    addressDescription: getFieldSchema("addressDescription"),
    number: getFieldSchema("number"),
    addressComplement: getFieldSchema("addressComplement"),
    companyName: getFieldSchema("companyName"),
    jobPosition: getFieldSchema("jobPosition"),
    neighborhood: getFieldSchema("neighborhood"),
    city: getFieldSchema("city"),
    state: getFieldSchema("state"),
  });

  const formMethods = useForm({
    defaultValues: { ...defaultValues, ...initialValues },
    resolver: yupResolver(SignUpSchema),
  });

  const renderedFieldNames = mandatoryFieldNames.filter(
    (fieldName) => fieldName !== signUpParamsQuery.data?.signUpVerificationField
  );

  const signUp = useSignUpUser({
    config: {
      onSuccess: () => {
        createNotification({
          type: "success",
          message: "Usuário criado com sucesso",
        });
      },
    },
  });
  const { handleSubmit } = formMethods;

  const onSubmit = (values) => {
    const requestData = values;

    if (!mandatoryFieldNames.includes("password")) {
      requestData["password"] =
        signUpParamsQuery.data?.AUTOCADASTRO_SENHA_PADRAO;
    }

    if (values.birthDayDate) {
      requestData["birthDayDate"] = values.birthDayDate.format(
        "YYYY-MM-DD HH:mm:ss"
      );
    }

    signUp.mutate(requestData, { onSuccess });
  };
  return (
    <StyledForm onSubmit={handleSubmit(onSubmit)}>
      {renderedFieldNames.map((fieldName) => {
        return <Field formMethods={formMethods} fieldName={fieldName} />;
      })}
      <button type="submit" hidden ref={submitButtonRef} />
    </StyledForm>
  );
}
